// 数量改变
    function changeQuantity(index,type,flag){

        var currentQuantity = parseInt($('#product-'+flag+"-quantityLine"+index).val());


        switch (type){
            // 减少
            case 'decrease':
                if (currentQuantity > 1){
                    currentQuantity = currentQuantity - 1;
                }
                break;
            // 增加
            case 'add':
                if (currentQuantity < 100){
                    currentQuantity = currentQuantity + 1;
                }
                break;
        }

        // 设置值
        $('#product-'+flag+"-quantityLine"+index).val(currentQuantity);
        $('#product-'+flag+"-quantityForm-"+index).val(currentQuantity);
    }
    // 监听修改数量
    $("#quantityInput-{{ section.settings.flag }}").bind('input propertychange',function(event){
        // 当前值
        let currentQuantity = $(this).val();
        // 替换id中间值，将数量同步到form表单中
        let formQuantityInputId = $(this).attr('id').replaceAll("quantityLine","quantityFormLine");
        $("#"+formQuantityInputId).val(currentQuantity);
    });